import React from 'react';
import { Route, Router, Switch, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { history } from 'store';
import { GateWayContainer, UserContext, AuthContext } from '../GateWay/GateWay';
import { LoginPage } from 'core/containers';
import { AuthSelectors } from 'store/features/auth/selectors';
import { routes, IRoute } from './route-list';
import { DefaultLayout } from '../DefaultLayout/DefaultLayout';
import { localStorageUtils } from 'shared/utils';

export const Routes: React.FunctionComponent = (): JSX.Element => {
  /**
   * Store
   */
  const isAuthenticated = useSelector(AuthSelectors.getIsLoggedIn);

  // Why not userContext? we need to consume the context after it gets loaded on the gateway,
  // otherwise we will get the default values and we don't want that.
  const canSeeRoute = (route: IRoute, userContext: AuthContext) => {
    if (!route.scope) {
      return true;
    }

    if (userContext.isSuper) {
      return true;
    }

    if (
      route.scope === userContext.scope &&
      // No route permission or user has the current permission or is an admin
      (!route.permission || userContext.hasPermission(route.permission) || userContext.isAdmin) &&
      // User doesn't have a hidden for permission
      (!route.hideForPermissions || !route.hideForPermissions.some(p => userContext.hasPermission(p)))
    ) {
      return true;
    }

    return false;
  };
  if (window.location.pathname !== '/' && !isAuthenticated) {
    localStorageUtils.set('redirectTo', window.location.pathname);
  }
  return (
    <Router history={history}>
      {isAuthenticated ? (
        <GateWayContainer>
          <DefaultLayout>
            <UserContext.Consumer>
              {userContext => (
                <Switch>
                  {routes.map((route: IRoute) => {
                    if (canSeeRoute(route, userContext)) {
                      return (
                        <Route path={route.path} key={route.path as string} {...route.options}>
                          {route.component()}
                        </Route>
                      );
                    }
                    return null;
                  })}
                </Switch>
              )}
            </UserContext.Consumer>
          </DefaultLayout>
        </GateWayContainer>
      ) : (
        <Switch>
          <Route path="/" exact component={LoginPage} />
          <Redirect from="*" to="/" />
        </Switch>
      )}
    </Router>
  );
};
